import React from 'react';
import { SkeletonItem } from '@atlaskit/menu';
import { testIdConcat } from '@atlassian/jira-navigation-apps-common/src/utils/test-id.tsx';
import type { MenuSkeletonFooterProps } from './types.tsx';

export const MenuSkeletonFooter = ({ testIdPrefix, numItems = 2 }: MenuSkeletonFooterProps) => (
	<div data-testid={testIdConcat(testIdPrefix, 'skeleton')}>
		<SkeletonItem width="50%" />
		{numItems >= 2 && <SkeletonItem width="50%" />}
	</div>
);
